import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { changeNumberWorkaroundColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getChangeNumber } from "../../../../api/sim";

const COPY_KEYS = ["id", "old_iccid", "iccid", "old_msisdn", "new_msisdn", "status", "created_at", "last_updated"];

const TmobilejChangeNumberWorkaroundBatch = () => (
  <BatchDetail
    title="Change Number Workaround"
    apiGet={__getChangeNumber}
    client={CLIENTS.tmobilej_workaround}
    columnsFactory={changeNumberWorkaroundColumns}
    copyKeys={COPY_KEYS}
    exportAction="change_number_workaround"
    retryOperation="change_number_workaround"
    showTerminate
    getRowPath={(row) => `/tmobilej/change_number_workaround/${row.id}`}
  />
);

export default TmobilejChangeNumberWorkaroundBatch;
